/**
 * created by li si yi
 * Echarts组件
 */
import React, {Component} from 'react';
import ReactEcharts from 'echarts-for-react';
import moment from "moment";
import BaseComponent from "../../../../base/BaseComponent";

export default class Echarts extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            chartsData: []
        }
    }

    componentDidMount() {
        // this.state.chartsData = JSON.parse(JSON.stringify(this.props.chartsData));
    }

    render() {
        // if(res.week.length && res.weekPublishCount.length) {
        //     for (let i=0;i<res.week.length;i++) {
        //         dataByXinWeb.data5.push(
        //             {time: res.week[i], count: res.weekPublishCount[i]}
        //         )
        //     }
        // }
        // if(res.month.length && res.monthPublishCount.length) {
        //     for (let i=0;i<res.month.length;i++) {
        //         dataByXinWeb.data30.push(
        //             {time: res.month[i], count: res.monthPublishCount[i]}
        //         )
        //     }
        // }

        let chartsData = this.props.chartsData;
        let DataX = [];
        if (chartsData) {
            DataX = Object.keys(chartsData)
        }
        let DataY = [];
        if (DataX && DataX.length > 0) {
            DataX.forEach((item, index) => {
                DataY.push(chartsData[item])
            })
        }
        let color = this.props?.myChartsColor || "199, 227, 253";// 传过来的颜色
        let option = {
            tooltip: {
                trigger: 'axis',
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: DataX,
                axisLine: {
                    lineStyle: {
                        color: '#7f7f7f',
                        width: 1,//这里是为了突出显示加上的
                        shadowOffsetX: 8,
                        shadowColor: '#7f7f7f'
                    },
                    symbol: ['none', 'arrow'],
                    symbolSize: [8, 8],
                    symbolOffset: 15
                },
                /* splitLine: {
                         show:true,
                         // 使用深浅的间隔色
                         color: ['#00e2ff']
                 },*/
                axisLabel: {
                    showMaxLabel: true,// x轴最后一个显示
                    show: true,
                    interval: DataX.length > 15 ? 4 : 0,
                    rotate: 0,
                    textStyle: {
                        color: '#7f7f7f',
                        fontSize: 12,
                        padding: 10,
                    }
                },
                axisTick: {
                    show: false,
                }

            },

            yAxis: {
                // scale:true,
                min: DataY.some(item => item >= 1) ? 0 : 3,
                minInterval: 1,// y轴整数
                type: 'value',
                splitNumber: 5,
                splitLine: {
                    lineStyle: {
                        // 使用深浅的间隔色
                        color: ['#eee']
                    }
                },
                axisLine: {
                    lineStyle: {
                        color: '#7f7f7f',
                        width: 1,//这里是为了突出显示加上的
                        shadowOffsetY: -8,
                        shadowColor: '#7f7f7f'
                    },
                    symbol: ['none', 'arrow'],
                    symbolSize: [8, 8],
                    symbolOffset: 15
                },
                axisLabel: {
                    showMaxLabel: true,
                    formatter: (value, index) => {
                        if (value < 1000) return value;
                        const si = [
                            {value: 1, symbol: ""},
                            {value: 1E3, symbol: "K"},
                            {value: 1E6, symbol: "M"},
                            {value: 1E9, symbol: "G"},
                            {value: 1E12, symbol: "T"},
                            {value: 1E15, symbol: "P"},
                            {value: 1E18, symbol: "E"}
                        ];
                        let i;
                        for (i = si.length - 1; i > 0; i--) {
                            if (value >= si[i].value) {
                                break;
                            }
                        }
                        return (value / si[i].value).toFixed(0) + si[i].symbol;
                        // return value.toFixed(3);
                    },
                    textStyle: {
                        color: '#7f7f7f',
                        fontSize: 12,
                    }
                },
                axisTick: {
                    show: false,
                },
            },
            series: [
                {
                    name: '发布数',
                    type: 'line',
                    smooth: true,
                    smoothMonotone: 1,
                    smoothType: 'monotone',
                    itemStyle: {  /*设置折线颜色*/
                        normal: {
                            color: 'rgb(' + color + ')',
                            width: 2,
                        }
                    },
                    symbolSize: 5,
                    lineStyle: {
                        normal: {
                            width: 2,
                        },

                    },
                    data: DataY,
                    areaStyle: {
                        opacity: 0.3,
                        color: 'rgba(' + color + ')',
                        //     {
                        //     type: 'linear',
                        //     x: 0,
                        //     y: 0,
                        //     x2: 0,
                        //     y2: 1,
                        //     colorStops: [{
                        //         offset: 0, color: 'rgba(29,232,227,.8)',// 0% 处的颜色
                        //     }, {
                        //         offset: 0.5, color: 'rgba(29,232,227,.3)'// 100% 处的颜色
                        //     }, {
                        //         offset: 1, color: 'rgba(29,232,227,.1)'
                        //     }],
                        //     globalCoord: false // 缺省为 false
                        // }
                    },
                }],
            grid: {
                show: true,
                borderColor: 'transparent',
                x: 50,
                x2: 50,
                y: 20,
                y2: 40,
            },
        };
        return (
            <div>
                <ReactEcharts
                    option={option}
                    notMerge={true}
                    lazyUpdate={true}
                    style={{width: '100%', height: '195px'}}
                />
            </div>
        )
    };
}